



export const BASE_URL='https://prod.yourdigiwill.com/api/';
export const PLAYSTORE_URL='https://play.google.com/store/apps/details?id=com.app.yourdigiwillapp';
export const BASE_URLS="https://prod.yourdigiwill.com/web/";
/* export const BASE_URL='http://localhost:8000/api/' */
export const TRACKING_CODE='UA-219299967-2'